<template>
    <div class="content-editable-input">
        <div
            ref="editable"
            class="content-editable-input__input"
            :contenteditable="!disabled"
            @input="onInput"
            @keydown.enter.prevent.stop
            @blur.prevent.stop="onBlur"
        />
        <span
            v-if="!modelValue.length && placeholder"
            class="content-editable-input__placeholder"
            @click="$refs.editable.focus()"
        >
            {{ placeholder }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ContentEditableInput',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        modelModifiers: {
            type: Object,
            default: () => ({})
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue', 'blur'],
    data() {
        return {
            skipNextBlurEvent: false
        };
    },
    watch: {
        modelValue() {
            if (!this.modelValue) {
                this.$refs.editable.innerText = '';
            }
        }
    },
    mounted() {
        this.$refs.editable.innerText = this.modelValue;
    },
    methods: {
        onInput(e) {
            let value = e.target.innerText;

            if (this.modelModifiers.trim) {
                value = value.trim();
            }

            this.$emit('update:modelValue', value);
        },

        blur(skipNextBlur) {
            if (skipNextBlur) {
                this.skipNextBlurEvent = true;
            }

            this.$refs.editable.blur();
        },

        onBlur() {
            if (this.skipNextBlurEvent) {
                this.skipNextBlurEvent = false;
                return;
            }

            this.$emit('blur');
        }
    }
};
</script>

<style src="./ContentEditableInput.scss" lang="scss"></style>
